var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      on: {
        change: function ($event) {
          return _vm.$emit("toggle")
        },
        drop: function ($event) {
          $event.preventDefault()
          return _vm.onDrop.apply(null, arguments)
        },
        dragstart: function ($event) {
          $event.preventDefault()
        },
        dragenter: function ($event) {
          $event.preventDefault()
          return _vm.onDragEnter.apply(null, arguments)
        },
        dragleave: function ($event) {
          $event.preventDefault()
          return _vm.onDragLeave.apply(null, arguments)
        },
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.onDragOver.apply(null, arguments)
        },
      },
    },
    [
      _c("PositionWarning", {
        attrs: { show: _vm.showPositionWarning, message: _vm.positionWarning },
        on: { dismiss: _vm.dismissWarning },
      }),
      _vm._v(" "),
      _c(
        "div",
        { ref: "cropImage", attrs: { "is-show": _vm.isCropMode } },
        [
          _c("CropImage", {
            attrs: { "is-show": _vm.isCropMode, src: _vm.target.getSrc() },
            on: {
              onSave: (data) => _vm.onChange("newCrop", data),
              onCancel: function ($event) {
                _vm.isCropMode = false
              },
              onAutoCrop: _vm.handleAutoCrop,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.options.isSelectImageFromBackground || _vm.options.isStaticImage
        ? [
            _c(
              "div",
              { staticClass: "layout-sidebar-section" },
              [
                _c(
                  "div",
                  {
                    staticClass: "layout-sidebar-section-title",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("toggleSection", "themeSection")
                      },
                    },
                  },
                  [
                    _c("strong", [_vm._v("Image & Theme")]),
                    _vm._v(" "),
                    _c("b-icon", {
                      attrs: {
                        icon: _vm.isOpen.themeSection
                          ? "chevron-up"
                          : "chevron-down",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  [
                    _c(
                      "b-collapse",
                      { attrs: { visible: _vm.isOpen.themeSection } },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "b-form-group",
                              { staticClass: "mb-0" },
                              [
                                !_vm.options.isStaticImage
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "primary" },
                                        on: {
                                          click: function ($event) {
                                            _vm.imageSrc && !_vm.imageIsDefault
                                              ? _vm.onChange(
                                                  "selectBackground",
                                                  "Replace"
                                                )
                                              : _vm.onChange("selectBackground")
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "cloud-upload" },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              `${
                                                _vm.imageSrc &&
                                                !_vm.imageIsDefault
                                                  ? "Replace"
                                                  : "Select…"
                                              }`
                                            ) +
                                            "\n              "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.options.isStaticImage
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        attrs: {
                                          title: "Choose product image...",
                                          variant: "primary",
                                        },
                                        on: {
                                          click: _vm.toggleProductDropdown,
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: "/img/icons/choose-product.png",
                                            alt: "choose-product-icon",
                                            width: "20",
                                            height: "20",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.imageSrc
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "download-image my-2",
                                        attrs: {
                                          href: _vm.imageSrc,
                                          download: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName:
                                                  "v-b-tooltip.hover.viewport.noninteractive",
                                                value: "Remove image",
                                                expression: "'Remove image'",
                                                modifiers: {
                                                  hover: true,
                                                  viewport: true,
                                                  noninteractive: true,
                                                },
                                              },
                                            ],
                                            staticClass: "close-btn",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.onChange(
                                                  "deleteConfirmationImage"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("b-icon", {
                                              attrs: { icon: "x" },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.imagePreviewSrc
                                          ? _c("b-img", {
                                              staticClass: "img-preview",
                                              attrs: {
                                                src: _vm.imagePreviewSrc,
                                                fluid: "",
                                                rounded: "",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName:
                                                  "v-b-tooltip.hover.viewport.noninteractive",
                                                value: "Download",
                                                expression: "'Download'",
                                                modifiers: {
                                                  hover: true,
                                                  viewport: true,
                                                  noninteractive: true,
                                                },
                                              },
                                            ],
                                            staticClass: "download-image-href",
                                            attrs: {
                                              href: _vm.imageSrc,
                                              download: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          },
                                          [
                                            _c("b-icon", {
                                              attrs: { icon: "download" },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        !_vm.options.isStaticImage
                                          ? _c(
                                              "button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover.viewport.noninteractive",
                                                    value: "Edit image",
                                                    expression: "'Edit image'",
                                                    modifiers: {
                                                      hover: true,
                                                      viewport: true,
                                                      noninteractive: true,
                                                    },
                                                  },
                                                ],
                                                staticClass: "edit-image-btn",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.showImageEditorModal.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("b-icon", {
                                                  attrs: {
                                                    icon: "pencil-square",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    on: {
                                      change: function ($event) {
                                        return _vm.onChange(
                                          "setIsClippingMask",
                                          _vm.isClippingMask
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.isClippingMask,
                                      callback: function ($$v) {
                                        _vm.isClippingMask = $$v
                                      },
                                      expression: "isClippingMask",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Create Clipping Mask\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Theme",
                                  "label-cols": "3",
                                  "invalid-feedback": "No theme selected",
                                  state: !!_vm.selectedTheme,
                                },
                              },
                              [
                                _c("Multiselect", {
                                  attrs: {
                                    options: _vm.cThemesOptions,
                                    label: "name",
                                    "track-by": "id",
                                    placeholder: "Select option",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onChange(
                                        "selectTheme",
                                        _vm.selectedTheme
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.selectedThemeObj,
                                    callback: function ($$v) {
                                      _vm.selectedThemeObj = $$v
                                    },
                                    expression: "selectedThemeObj",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.options.isFileImage
        ? _c(
            "div",
            { staticClass: "layout-sidebar-section" },
            [
              _c(
                "div",
                {
                  staticClass: "layout-sidebar-section-title",
                  on: {
                    click: function ($event) {
                      return _vm.$emit(
                        "toggleSection",
                        "productSettingsSection"
                      )
                    },
                  },
                },
                [
                  _c("strong", [_vm._v("Product Settings")]),
                  _vm._v(" "),
                  _c("b-icon", {
                    attrs: {
                      icon: _vm.isOpen.productSettingsSection
                        ? "chevron-up"
                        : "chevron-down",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                [
                  _c(
                    "b-collapse",
                    { attrs: { visible: _vm.isOpen.productSettingsSection } },
                    [
                      _c(
                        "div",
                        [
                          _c("ProductImageDropdown", {
                            ref: "productImageDropdown",
                            attrs: {
                              "is-file-image": _vm.options.isFileImage,
                              "is-tab-active": _vm.isTabActive,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onChange(
                                  "productImage",
                                  _vm.objectInput.fileIds
                                )
                              },
                              uploadInput: (fileIds) =>
                                _vm.onChange("productImage", {
                                  productIds: fileIds,
                                  type: "uploaded_product_image",
                                }),
                            },
                            model: {
                              value: _vm.objectInput.fileIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.objectInput, "fileIds", $$v)
                              },
                              expression: "objectInput.fileIds",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : [
            _c("ProductImageDropdown", {
              ref: "productImageDropdown",
              attrs: {
                "is-file-image": false,
                "is-tab-active": _vm.isTabActive,
              },
              on: {
                input: function ($event) {
                  return _vm.onChange("productImage", _vm.objectInput.fileIds)
                },
                uploadInput: (fileIds) =>
                  _vm.onChange("productImage", {
                    productIds: fileIds,
                    type: "uploaded_product_image",
                  }),
              },
              model: {
                value: _vm.objectInput.fileIds,
                callback: function ($$v) {
                  _vm.$set(_vm.objectInput, "fileIds", $$v)
                },
                expression: "objectInput.fileIds",
              },
            }),
          ],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "borderSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Border")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.borderSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.borderSection } },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Border color", "label-cols": "4" } },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("ColorPicker", {
                                attrs: {
                                  value: _vm.target.stroke,
                                  themes: _vm.themes,
                                  copy: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.onChange("strokeColor", $event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  staticClass: "ms-2",
                                  attrs: {
                                    variant: "primary",
                                    size: "sm",
                                    title: "Use background color",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChange(
                                        "strokeColor",
                                        _vm.target.fill
                                      )
                                    },
                                  },
                                },
                                [_c("b-icon", { attrs: { icon: "back" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.options.isBackgroundThemeImage
                        ? _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Border width",
                                disabled: _vm.target.locked,
                              },
                            },
                            [
                              _c(
                                "b-input-group",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c("b-input", {
                                              attrs: {
                                                min: 0,
                                                max: _vm.maxStrokeWidth,
                                                type: "number",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.onChange(
                                                    "strokeWidth",
                                                    _vm.localStrokeWidth
                                                  )
                                                },
                                              },
                                              model: {
                                                value: _vm.localStrokeWidth,
                                                callback: function ($$v) {
                                                  _vm.localStrokeWidth = $$v
                                                },
                                                expression: "localStrokeWidth",
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2730372846
                                  ),
                                },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      min: 0,
                                      max: _vm.maxStrokeWidth,
                                      type: "range",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onChange(
                                          "strokeWidth",
                                          _vm.localStrokeWidth
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.localStrokeWidth,
                                      callback: function ($$v) {
                                        _vm.localStrokeWidth = $$v
                                      },
                                      expression: "localStrokeWidth",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.options.isUploadImage
        ? _c(
            "div",
            { staticClass: "layout-sidebar-section" },
            [
              _c(
                "div",
                {
                  staticClass: "layout-sidebar-section-title",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("toggleSection", "imageSettingsSection")
                    },
                  },
                },
                [
                  _c("strong", [_vm._v("Image Settings")]),
                  _vm._v(" "),
                  _c("b-icon", {
                    attrs: {
                      icon: _vm.isOpen.imageSettingsSection
                        ? "chevron-up"
                        : "chevron-down",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                [
                  _c(
                    "b-collapse",
                    { attrs: { visible: _vm.isOpen.imageSettingsSection } },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Image", "label-cols": "3" } },
                            [
                              _c("b-form-file", {
                                attrs: {
                                  placeholder: "Choose a file",
                                  "drop-placeholder": "Drop file here",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.onChange("upload", $event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.options.isOutline
        ? _c(
            "div",
            { staticClass: "layout-sidebar-section" },
            [
              _c(
                "div",
                {
                  staticClass: "layout-sidebar-section-title",
                  on: {
                    click: function ($event) {
                      return _vm.$emit(
                        "toggleSection",
                        "outlineSettingsSection"
                      )
                    },
                  },
                },
                [
                  _c("strong", [_vm._v("Outline Settings")]),
                  _vm._v(" "),
                  _c("b-icon", {
                    attrs: {
                      icon: _vm.isOpen.outlineSettingsSection
                        ? "chevron-up"
                        : "chevron-down",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                [
                  _c(
                    "b-collapse",
                    { attrs: { visible: _vm.isOpen.outlineSettingsSection } },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Outline", "label-cols": "3" } },
                            [
                              _c("b-form-input", {
                                on: {
                                  change: function ($event) {
                                    return _vm.onChange(
                                      "productOutline",
                                      _vm.outlineData
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.objectInput.fileOutlineId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.objectInput,
                                      "fileOutlineId",
                                      $$v
                                    )
                                  },
                                  expression: "objectInput.fileOutlineId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            { attrs: { label: "Color", "label-cols": "3" } },
                            [
                              _c("ColorPicker", {
                                on: {
                                  input: function ($event) {
                                    return _vm.onChange(
                                      "productOutline",
                                      _vm.outlineData
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.objectInput.fileOutlineColor,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.objectInput,
                                      "fileOutlineColor",
                                      $$v
                                    )
                                  },
                                  expression: "objectInput.fileOutlineColor",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.target &&
      (_vm.target.id.startsWith("bk_theme_img_") ||
        _vm.target.id.startsWith("add_bk_theme_img_"))
        ? _c("ObjectFillFit", {
            attrs: { target: _vm.target, "is-open": _vm.isOpen },
            on: { toggleSection: _vm.toggleSectionHandler },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.options.isHtmlTable,
              expression: "options.isHtmlTable",
            },
          ],
          staticClass: "mb-2",
          attrs: { variant: "success" },
          on: { click: _vm.initTableEditor },
        },
        [_vm._v("\n    Edit Table\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "opacityAndScaleSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Opacity & Scale")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.opacityAndScaleSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.opacityAndScaleSection } },
                [
                  _c(
                    "div",
                    {
                      on: {
                        change: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Opacity" } },
                        [
                          _c(
                            "b-input-group",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "append",
                                  fn: function () {
                                    return [
                                      _c("b-input", {
                                        attrs: {
                                          min: "0",
                                          max: "1",
                                          step: "0.01",
                                          type: "number",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onChange(
                                              "opacity",
                                              $event
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.opacity,
                                          callback: function ($$v) {
                                            _vm.opacity = $$v
                                          },
                                          expression: "opacity",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("b-input", {
                                attrs: {
                                  min: "0",
                                  max: "1",
                                  step: "0.01",
                                  type: "range",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.onChange("opacity", $event)
                                  },
                                },
                                model: {
                                  value: _vm.opacity,
                                  callback: function ($$v) {
                                    _vm.opacity = $$v
                                  },
                                  expression: "opacity",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: { disabled: _vm.target.locked },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between",
                                    },
                                    [
                                      _c("span", [_vm._v("Scale")]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.percentOfTemplate) +
                                            "% of Template"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-input-group",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "append",
                                  fn: function () {
                                    return [
                                      _c("b-input", {
                                        attrs: {
                                          min: "0",
                                          max: "10",
                                          step: "0.001",
                                          type: "number",
                                          disabled: _vm.isScaleDisabled,
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onChange("scale", $event)
                                          },
                                        },
                                        model: {
                                          value: _vm.scale,
                                          callback: function ($$v) {
                                            _vm.scale = $$v
                                          },
                                          expression: "scale",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("b-input", {
                                attrs: {
                                  min: "0",
                                  max: "10",
                                  step: "0.001",
                                  type: "range",
                                  disabled: _vm.isScaleDisabled,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.onChange("scale", $event)
                                  },
                                },
                                model: {
                                  value: _vm.scale,
                                  callback: function ($$v) {
                                    _vm.scale = $$v
                                  },
                                  expression: "scale",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          on: {
            change: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
            },
          },
        },
        [
          _c("PositionAndSize", {
            attrs: {
              x: parseFloat(_vm.objectInput.left),
              y: parseFloat(_vm.objectInput.top),
              h: parseFloat(_vm.objectInput.height),
              w: parseFloat(_vm.objectInput.width),
              "aspect-ratio-option:": "",
              "is-scale-disabled": _vm.isScaleDisabled,
              "is-open": _vm.isOpen,
            },
            on: {
              toggleSection: _vm.toggleSectionHandler,
              input: _vm.onChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "actionSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Actions")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.actionSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.actionSection } },
                [
                  _c(
                    "div",
                    [
                      _vm.isRelatedFieldChangeAvailable
                        ? _c(
                            "b-form-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Related field" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          value: _vm.target.relatedField?.field,
                                          options: _vm.relatedTemplateFields,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onChange(
                                              "changeRelatedField",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Margin" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          value: _vm.target.relatedField
                                            ? _vm.target.relatedField.margin
                                            : 5,
                                          type: "number",
                                          min: "0",
                                          step: "1",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onChange(
                                              "changeMargin",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-start mb-3",
                        },
                        [
                          _c(
                            "div",
                            [
                              _vm.options.isFileImage
                                ? _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass: "mt-1 d-none",
                                      attrs: { size: "sm" },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onChange(
                                            "autoPosition",
                                            _vm.objectInput.isAutoPosition
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.objectInput.isAutoPosition,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.objectInput,
                                            "isAutoPosition",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "objectInput.isAutoPosition",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Auto position\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "image-editor-actions image-editor-actions--bg-actions mt-3",
                            },
                            [
                              _vm.options.isSelectImageFromBackground
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      attrs: {
                                        title:
                                          _vm.resolveScaleImageAction("width")
                                            .tooltip,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.onChange(
                                            _vm.resolveScaleImageAction("width")
                                              .action,
                                            "width"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: { src: "/img/icons/expand.svg" },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.options.isSelectImageFromBackground
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      attrs: {
                                        title:
                                          _vm.resolveScaleImageAction("height")
                                            .tooltip,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.onChange(
                                            _vm.resolveScaleImageAction(
                                              "height"
                                            ).action,
                                            "height"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          transform: "rotate(90deg)",
                                        },
                                        attrs: { src: "/img/icons/expand.svg" },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.options.isSelectImageFromBackground
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      attrs: {
                                        title: "Scale to template size",
                                      },
                                      on: {
                                        click: _vm.handleScaleToTemplateSize,
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: "/img/icons/full-screen.svg",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.options.isConvertibleToSmartObject
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      attrs: {
                                        title: "Convert to SmartObject",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onChange(
                                            "convertToSmartObject"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: "/img/icons/smart.svg",
                                          alt: "convert-to-smart-object-icon",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  attrs: {
                                    title: _vm.resolveCenterImageAction.tooltip,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChange(
                                        _vm.resolveCenterImageAction.action,
                                        _vm.resolveCenterImageAction
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/img/icons/center-image.svg",
                                      alt: "center-icon",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  attrs: {
                                    title:
                                      _vm.resolveHorizontalCenterImageAction
                                        .tooltip,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChange(
                                        _vm.resolveHorizontalCenterImageAction
                                          .action,
                                        _vm.resolveCenterImageAction
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/img/icons/align-center.png",
                                      alt: "align-center-icon",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  attrs: {
                                    title:
                                      _vm.resolveVerticalCenterImageAction
                                        .tooltip,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChange(
                                        _vm.resolveVerticalCenterImageAction
                                          .action,
                                        _vm.resolveCenterImageAction
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/img/icons/vertical-alignment.png",
                                      alt: "align-center-icon",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  staticClass: "flip-x",
                                  attrs: { title: "Flip horizontal" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChange("flipX")
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/img/icons/horizontal-flip.svg",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  staticClass: "flip-y",
                                  attrs: { title: "Flip vertical" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChange("flipY")
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/img/icons/vertical-flip.svg",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.options.isStaticImage
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "crop",
                                      attrs: { title: "Crop" },
                                      on: { click: _vm.handleCrop },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "x-svg",
                                          attrs: { width: "22", height: "22" },
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              href: "/img/icons/sprite.svg#crop",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.target.originalPathForRestoreAfterCrop
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass:
                                        "restore-original undo-button",
                                      attrs: {
                                        title: "Restore original image (crop)",
                                      },
                                      on: {
                                        click: _vm.restoreOriginalAfterCrop,
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: "/img/icons/reset.svg",
                                          alt: "restore",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isBgThemeImage
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "remove-gb",
                                      attrs: { title: "Remove background" },
                                      on: { click: _vm.handleRemoveBackground },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: "/img/icons/remove-bg.svg",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isFileImage
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "remove-gb",
                                      attrs: { title: "Remove background" },
                                      on: {
                                        click:
                                          _vm.showProductImageRemoveBGModal,
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: "/img/icons/remove-bg.svg",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  attrs: { title: "Reset aspect ratio" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChange("resetAspectRatio")
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/img/icons/reset-aspect-ratio.svg",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.viewport.noninteractive",
                                      value: "Reset to original dimensions",
                                      expression:
                                        "'Reset to original dimensions'",
                                      modifiers: {
                                        hover: true,
                                        viewport: true,
                                        noninteractive: true,
                                      },
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChange(
                                        "resetToOriginalDimensions"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/img/icons/reset-to-original-dimensions.svg",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "position-fixed apply-to-image-dropdwon-section" },
        [_c("ApplyToAllImageDropdown", { attrs: { target: _vm.target } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-wrap gap-2 mb-1" },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "danger" },
              on: {
                click: function ($event) {
                  return _vm.onChange("deleteConfirmation")
                },
              },
            },
            [
              _c("b-icon", { attrs: { icon: "trash" } }),
              _vm._v("\n      Delete Layer\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  value: "Mask",
                  expression: "'Mask'",
                  modifiers: { hover: true },
                },
              ],
              staticClass: "btn btn-primary mask-settings",
              attrs: { "data-id": _vm.selectedInstance.canvas.instance_id },
            },
            [_c("b-icon", { attrs: { icon: "mask" } })],
            1
          ),
          _vm._v(" "),
          _c("LockToggle"),
          _vm._v(" "),
          _c("SeeThrough"),
          _vm._v(" "),
          _c("RestoreSeeThrough"),
        ],
        1
      ),
      _vm._v(" "),
      _c("ProductImageRemoveBGModal", {
        ref: "productImageRemoveBGModal",
        on: {
          replaceExistingImage: _vm.replaceImage,
          copyAndReplaceImage: _vm.copyImage,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }